import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

const service = createService(SERVICE_INSTANCES.dashboard)

export const DASHBOARD_INSTANCE = service.instanceKey

export const DASHBOARD_ENDPOINTS = {
  DASHBOARD_EVENTS: "/admin/view/dashboard_events",
  DASHBOARD_ACTIONS: "/admin/view/dashboard_actions",
  DASHBOARD_PAYROLL: "/admin/view/dashboard_payroll",
  EMPLOYEE_DASHBOARD: "/employee/view/dashboard_index",
  EMPLOYEE_DASHBOARD_EVENTS: "/employee/view/dashboard_events",
  EMPLOYEE_DASHBOARD_ACTIONS: "/employee/view/dashboard_actions",
  EMPLOYEE_DASHBOARD_PAYSLIP: "/employee/view/dashboard_payslip",
} as const

export const dashboardService = {
  instanceKey: service.instanceKey,

  getDashboardEvents: (params?: { start_date?: string; end_date?: string }) =>
    service.get(DASHBOARD_ENDPOINTS.DASHBOARD_EVENTS, params),
  getDashboardActions: (params?: { start_date?: string; end_date?: string }) =>
    service.get(DASHBOARD_ENDPOINTS.DASHBOARD_ACTIONS, params),
  getDashboardPayroll: (currency: string) =>
    service.get(DASHBOARD_ENDPOINTS.DASHBOARD_PAYROLL, { currency }),
  getEmployeeDashboard: () =>
    service.get(DASHBOARD_ENDPOINTS.EMPLOYEE_DASHBOARD),
  getEmployeeDashboardEvents: () =>
    service.get(DASHBOARD_ENDPOINTS.EMPLOYEE_DASHBOARD_EVENTS),
  getEmployeeDashboardActions: () =>
    service.get(DASHBOARD_ENDPOINTS.EMPLOYEE_DASHBOARD_ACTIONS),
  getEmployeeDashboardPayslip: () =>
    service.get(DASHBOARD_ENDPOINTS.EMPLOYEE_DASHBOARD_PAYSLIP),
}
